import Blog from './Blog.es.js';
import ChromaticDark from './ChromaticDark.es.js';
import Chromatic from './Chromatic.es.js';
import CommunityChannels from './CommunityChannels.es.js';
import Courses from './Courses.es.js';
import Creator from './Creator.es.js';
import Distribution from './Distribution.es.js';
import Insider from './Insider.es.js';
import LandrFx from './LandrFx.es.js';
import Mastering from './Mastering.es.js';
import NetworkPro from './NetworkPro.es.js';
import NetworkServices from './NetworkServices.es.js';
import Network from './Network.es.js';
import Plugins from './Plugins.es.js';
import ProjectsBlue from './ProjectsBlue.es.js';
import ProjectsRed from './ProjectsRed.es.js';
import SamplesDark from './SamplesDark.es.js';
import Samples from './Samples.es.js';
import SessionsDark from './SessionsDark.es.js';
import Sessions from './Sessions.es.js';
import Tutorials from './Tutorials.es.js';
import Vocalign from './Vocalign.es.js';
var ProductIcon = {
  Blog: Blog,
  ChromaticDark: ChromaticDark,
  Chromatic: Chromatic,
  CommunityChannels: CommunityChannels,
  Courses: Courses,
  Creator: Creator,
  Distribution: Distribution,
  Insider: Insider,
  LandrFx: LandrFx,
  Mastering: Mastering,
  NetworkPro: NetworkPro,
  NetworkServices: NetworkServices,
  Network: Network,
  Plugins: Plugins,
  ProjectsBlue: ProjectsBlue,
  ProjectsRed: ProjectsRed,
  SamplesDark: SamplesDark,
  Samples: Samples,
  SessionsDark: SessionsDark,
  Sessions: Sessions,
  Tutorials: Tutorials,
  Vocalign: Vocalign
};
export { ProductIcon };